import axios from 'axios';

const SERVER_URL = process.env.REACT_APP_API_URL || 'http://localhost:1337';

export type EventDataType = {
  userData: {
    em?: string;
    ph?: string;
    fbc?: string;
    fbp?: string;
    fn?: string;
    ln?: string;
    db?: string;
    st?: string;
    zp?: string;
    country?: string;
    external_id?: string;
    subscription_id?: string;
    fb_login_id?: string;
    lead_id?: string;
    anon_id?: string;
    madid?: string;
    page_id?: string;
    page_scoped_user_id?: string;
    ctwa_clid?: string;
    ig_account_id?: string;
    ig_sid?: string;
  };
  customData?: {
    [key: string]: string | number | boolean;
  };
};

export const fireFBEvent = async (eventName: string, eventData: EventDataType = { userData: {} }) => {
  try {
    const response = await axios.post(
      `${SERVER_URL}/api/fb-analytics/fire-event`,
      {
        eventName,
        eventSource: 'funnel',
        userData: eventData.userData,
        customData: eventData?.customData,
      },
      { withCredentials: true }
    );
    console.log('FB event fired:', response.data);
  } catch (err) {
    console.error('Error firing FB event:', err);
  }
}
